export default {
  path: '/',
  meta: {
    title: '灸世家',
    scrollTop: 0,
    keepAlive:true,
    tab:true
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/`),
}



// WEBPACK FOOTER //
// ./src/views/Home/router.js